export function HowItWorks() {
  return (
    <section aria-labelledby="how-it-works-heading">
      <h2 className="section-heading" id="how-it-works-heading">
        Cómo funciona
      </h2>
      <div className="wireframe-columns">
        <div>
          <h3>Contrato</h3>
          <p>
            El motor lee el objeto <code>payload</code> de la envolvente como un documento OpenAPI 3.1: rutas,
            operaciones, parámetros, <code>requestBody</code>, <code>responses</code> y esquemas de
            seguridad. Cada caso de fallo generado enlaza a la propiedad exacta del documento que lo
            justifica (<code>evidencePath</code>), y se marca como <em>supuesto</em> cuando el motor infiere
            algo que el contrato no documenta explícitamente.
          </p>
          <h3>Límites</h3>
          <ul>
            <li>Hasta 60 rutas y 200 operaciones por documento.</li>
            <li>Hasta 1000 hallazgos visibles por ejecución (truncado explícito si se supera).</li>
            <li>Presupuesto de 5 segundos antes de abortar una ejecución.</li>
            <li>Exportación máxima de 5 MB, con redacción de cabeceras sensibles.</li>
          </ul>
        </div>
        <div>
          <h3>Arquitectura</h3>
          <p>
            Aplicación 100% estática: React + TypeScript en el navegador, reglas de dominio como funciones
            puras y ejecución en un Web Worker cancelable. No hay backend propio ni datos que salgan del
            dispositivo; el adaptador remoto opcional está deshabilitado por diseño (kill switch permanente
            en este MVP).
          </p>
          <h3>Validación sin <code>eval</code></h3>
          <p>
            La entrada se valida contra <code>contracts/input.schema.json</code> con un validador escrito a
            mano (sin <code>ajv</code> en tiempo de ejecución), compatible con una Content-Security-Policy
            estricta sin <code>unsafe-eval</code>.
          </p>
        </div>
      </div>
    </section>
  );
}
